<template>
  <div class="flex flex-col md:space-x-2 md:flex-row" v-if="property">
    <div class="relative w-full h-full">
      <img :src="property.photos[0]" class="w-full md:h-[550px]" alt="" />
      <div class="absolute top-0 left-0 mt-2 ml-2">
        <div
          class="text-[11px] p-1 text-white uppercase bg-gray-700 rounded-md opacity-80 font-medium"
        >
          {{ property.completion_status }}
        </div>
      </div>
    </div>
    <!-- <div class="w-[416px]">
      <div class="flex flex-col items-center justify-center space-y-2">
        <div class="relative w-full h-[272px]">
          <div
            class="absolute inset-0 bg-center bg-cover"
            style="background-image: url('/img/floorplan.webp')"
          ></div>
          <div class="absolute inset-0 bg-black opacity-60"></div>
        </div>
        <div
          class="absolute flex items-center justify-center h-8 bg-white rounded-lg shadow-md w-28 outline-blue-500 top-56"
        >
          <img src="@/assets/icons/plan.svg" class="w-5 h-5" alt="" />
          Floor plan
        </div>

        <div class="bg-stone-200 w-full h-[272px]"></div>
      </div>
    </div> -->
  </div>
</template>
<script>
//   import TagsView from "./TagsView.vue";
export default {
  components: {
    //   TagsView,
  },
  props: {
    property: Object,
  },
};
</script>
